import { nullSafeGet, nullSafeGetOrElse } from './DataAccessUtils';
import { getContactName } from './DataFormatterUtils';

export const getFieldTechContact = (fieldTech) => nullSafeGet('supplierContact', fieldTech);

export const getFieldTechDisplayName = (fieldTech) =>
	getContactName(getFieldTechContact(fieldTech) || {}).trim() ||
	nullSafeGetOrElse('name', fieldTech, '') ||
	nullSafeGetOrElse('email', fieldTech, '');

export const getFamilyNameAndGivenName = (fieldTech) => {
	const contact = getFieldTechDisplayName(fieldTech);
	const nameParts = contact.split(' ');
	return {
		nameFamily: nameParts[nameParts.length - 1],
		nameGiven: nameParts.slice(0, -1).join(' '),
	};
};
